/* MD Colección productos: el desplegable de orden recarga la página al cambiar,
   conservando el resto de parámetros de la URL y volviendo a la primera página */
(function () {
  'use strict';

  var ROOT = '.md-coleccion-productos';

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';

    /* Con JavaScript el botón "Aplicar" sobra: el cambio se envía solo. La clase la pone ya un
       script en línea de la sección (evita el salto de layout); aquí se repite para las secciones
       que inyecta el editor de temas, donde los scripts en línea no se ejecutan */
    container.classList.add('md-coleccion-productos--js');

    container.addEventListener('change', function (e) {
      var select = e.target.closest('.md-coleccion-productos__sort-select');
      if (!select || !container.contains(select)) return;

      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  var sections = document.querySelectorAll(ROOT);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var loaded = e.target.querySelectorAll(ROOT);
    for (var j = 0; j < loaded.length; j++) {
      initSection(loaded[j]);
    }
  });
})();
